export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6877.ebc5ad62.jpg";